/**
 * PullHud (A43.3) — HUD-спиннер pull-to-refresh: диск с SVG-дугой
 * role-цвета, выезжает из-за верхней кромки скролл-контейнера на резиновый
 * оффсет usePullToRefresh. Рендерить ПЕРВЫМ ребёнком скролл-контейнера
 * (host: sticky, height 0 — потока не занимает). Пока палец ведёт (pulling)
 * транзиций нет; отпускание — пружина к 0/REST; refreshing — вращение.
 */
import css from "./PullHud.module.css";

export interface PullHudProps {
  /** Резиновый оффсет из usePullToRefresh. */
  pull: number;
  pulling: boolean;
  refreshing: boolean;
}

export function PullHud({ pull, pulling, refreshing }: PullHudProps) {
  const on = pull > 0 || refreshing;
  return (
    <div className={css.host} aria-hidden="true">
      <div
        className={`${css.disc} ${pulling ? "" : css.ease}`}
        style={{
          transform: `translateY(${on ? pull : 0}px) rotate(${refreshing ? 0 : pull * 2.4}deg)`,
          opacity: on ? Math.min(1, pull / 40) : 0,
        }}
      >
        <svg className={refreshing ? css.spin : undefined} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round">
          <path d="M21 12a9 9 0 1 1-4.2-7.6" />
        </svg>
      </div>
    </div>
  );
}
